import { getFeatureEnabledForCountry } from '../featureEnabledForCountry';
import { useGetSessionCompany } from './useGetSessionCompany';

export const useGetFeatureEnabledForCountry = () => {
  const { sessionCompany } = useGetSessionCompany();
  const countryCode = sessionCompany?.CountryCode ?? '';
  return getFeatureEnabledForCountry(countryCode);
};

export { getFeatureEnabledForCountry };
